import { render, staticRenderFns } from "./SmsPriorityRules.vue?vue&type=template&id=382cd600&"
import script from "./SmsPriorityRules.vue?vue&type=script&lang=ts&"
export * from "./SmsPriorityRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports